// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class AssetGroup {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.persistentId = model.persistentId;
        this.brandId = model.brandId;
        this.name = model.meta.name;
        this.description = model.meta.description;
        this.isRoot = model.isRoot;
        this.childrenIds = model.childrenIds;
        this.path = new Array();
        this.assetIds = new Array();
        this.subgroupIds = new Array();
        this.parentGroupId = null;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.isAssetGroup = false;
        this.sourceId = null;
        this.sourceName = null;
        this.sources = [];
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    addChild(groupId) {
        this.subgroupIds.push(groupId);
    }
    addChildren(groupsIds) {
        this.subgroupIds = this.subgroupIds.concat(groupsIds);
    }
    setPath(segments) {
        this.path = segments;
    }
    setParentGroupId(parentGroupId) {
        this.parentGroupId = parentGroupId !== null && parentGroupId !== void 0 ? parentGroupId : null;
    }
}
